module.exports = __webpack_public_path__ + "public/img/bg-sertif-graduation.5dbfcf0c.jpg";